import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core';
import React from 'react';
import { withLocale } from '../../hocs/withLocale';
import UserHelper from '../../infrastructure/UserHelper';

interface BookingTermsAndConditionsProps {
  owner: {
    name: string;
    [key: string]: any;
  };
  translate: (key: string, data?: any, options?: any) => string;
  accepted?: boolean;
  onChange?: (accepted: boolean) => void;
}

export const BookingTermsAndConditions = withLocale(
  ({ owner, translate, accepted = false, onChange = () => {} }: BookingTermsAndConditionsProps) => {
    const termsAndConditions = UserHelper.getTermsAndConditions(owner);
    return (
      <FormControl required error={!accepted}>
        <FormControlLabel
          name="tcAccepted"
          control={
            <Checkbox
              checked={accepted}
              onChange={(event) => {
                onChange(event.target.checked);
              }}
            />
          }
          label={
            <label>
              {translate('manageRegistration.accept')}{' '}
              <a href="/VooptyComT_N_C.pdf" target="_blank">
                {translate('manageRegistration.tc')}
              </a>
              {!accepted && (
                <FormHelperText style={{ display: 'inline-block' }}>
                  &nbsp;*
                </FormHelperText>
              )}
              <br />
              {translate(
                'myClients.acceptTermsAndConditionsText',
                {
                  ownerName: owner.name,
                  link: termsAndConditions,
                },
                { renderInnerHtml: true }
              )}
            </label>
          }
        />
      </FormControl>
    );
  }
);